export const meetingsSelectors = {
  isFetching: state => state.meetings.isFetching,
  isPending: state => state.meetings.isPending,
  meetingError: state => state.meetings.errors,
};
